export default __webpack_public_path__ + "static/media/FSKoopman-ExtraBoldItalic.cc456131.woff2";